import * as _ from 'lodash';
import toast from 'react-hot-toast';

import { logout } from './auth';
import { isFetching } from './preloader';

export const actionWrapper = (action, errorCallback, withoutLoader) => async (dispatch, getState) => {
  try {

    !withoutLoader && dispatch(isFetching(true));
    const newState = await action(dispatch, getState);
    if (newState) {
      dispatch(newState);
    }
    !withoutLoader && dispatch(isFetching(false));
  } catch (error) {
    console.log('===error', error);
    dispatch(isFetching(false));
    const response = _.get(error, 'request.response');

    if (!response) {

      toast.error('Server error', {
        position: 'bottom-right',
        duration: 3000,
      });
    }

    try {
      const responseData = JSON.parse(response);

      console.log('===responseData', responseData);
      if (responseData.error === 'jwt expired') {
        return dispatch(logout());
      }

      if (errorCallback) {
        errorCallback(responseData.error || responseData.apiErrors, dispatch);
      } else {
        const errorMessage = responseData.error || responseData.apiErrors || error.message || 'Server error';

        toast.error(errorMessage, {
          position: 'bottom-right',
          duration: 3000,
        });
      }
    } catch (parseError) {

      toast.error(error.message || 'Server error', {
        position: 'bottom-right',
        duration: 3000,
      });
    }
  }
};
